import { type FieldContentsData } from 'javascripts/shared-types';
import CustomField from '../CustomField';

export default class NumberCustomField extends CustomField {
  exampleContents() {
    return {
      text: '9',
    };
  }

  contentsForRecord(record: any): FieldContentsData {
    const customFieldValue = this.customFieldValueForRecord(record);

    if (customFieldValue?.humanValue) {
      return {
        text: customFieldValue.humanValue,
      };
    }

    return {};
  }
}
